module.exports = __webpack_public_path__ + "static/media/trigger.d6475868.svg";